<script lang="ts">
  import * as L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import 'leaflet-gpx/gpx';
  import 'leaflet-active-area';
  import { onMount } from 'svelte';
  import { runs } from '../shared/stores/run-data-store';
  import { styles } from '../shared/styles/styles';
  import { pwmBoundary } from '../../public/assets/data/portland_boundary';

  let element: HTMLDivElement;
  let map: L.Map;
  const gpxLayers = L.layerGroup();

  export function getMap(): L.Map {
    return map;
  }

  export function fadeAllLayers() {
    gpxLayers.eachLayer((layer: L.Path) => layer.setStyle({ opacity: 0.2 }));
  }

  export function restoreAllLayers() {
    gpxLayers.eachLayer((layer: L.Path) => layer.setStyle({ opacity: styles.pathOpacity }));
  }

  onMount(() => {
    map = L.map(element, {
      center: {
        lat: 43.6751395334499,
        lng: -70.24924106430262,
      },
      minZoom: 8,
      zoom: 12,
    });
    (map as any).setActiveArea({
      position: 'absolute',
      height: '50%', // TODO: approximation
      width: '100%',
    });

    L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
      attribution: 'Map data &copy; <a href="http://www.osm.org">OpenStreetMap</a>',
    }).addTo(map);

    const boundary = L.geoJSON(pwmBoundary as any, { style: { fillColor: 'none' } });
    boundary.addTo(map);
    
    gpxLayers.addTo(map);

    runs.subscribe(($runData) => {
      $runData.forEach((run, i) => {
        run.gpx.addTo(gpxLayers);
      });
    });

    map.on('click', () => restoreAllLayers());
  });
</script>

<div bind:this={element} class="leaflet" />

<style lang="scss">
  .leaflet {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
</style>
